import Vue from 'vue'
import Router from 'vue-router'
import CoolingLoad from './views/CoolingLoad.vue'
import Sensors from './views/Sensors.vue'
import Fault from '@/views/Fault.vue'
import AnomalyDetection from '@/views/AnomalyDetection.vue'
import AnomalySummaryView from '@/views/AnomalySummaryView.vue'
import ControlLogic from '@/views/ControlLogic.vue'
import Notifications from '@/views/Notifications.vue'
import CondenserHealth from '@/views/faults/CondenserHealth.vue'
import EvaporatorHealth from '@/views/faults/EvaporatorHealth.vue'
import RefrigerantHealth from '@/views/faults/RefrigerantHealth.vue'
import CompressorHealth from '@/views/faults/CompressorHealth.vue'
import FacetPlots from '@/views/FacetPlots.vue'
import EnergyEfficiency from '@/views/EnergyEfficiency.vue'
import Settings from '@/views/Settings.vue'
import Help from '@/views/Help.vue'
import MaintenanceRecord from '@/views/MaintenanceRecord.vue'
import Equipments from '@/views/Equipments.vue'
import Facility from '@/views/Facility.vue'
import Points from '@/views/Points.vue'
import Config from '@/views/Config.vue'
import Parameter from '@/views/Parameter.vue'
import KPI from '@/views/KPI.vue'
import DynamicControlOutputPoints from '@/views/DynamicControlOutputPoints.vue'
import LoginPage from '@/views/LoginPage.vue'
import Summary from '@/views/Summary.vue'
import Report from '@/views/Report.vue'
import Rules from '@/views/Rules.vue'
import Refrigerant from '@/components/Refrigerant'
import Users from '@/views/Users.vue'
import ViewData from '@/views/ViewData.vue'
import MultiPlots from '@/views/MultiPlots.vue'
import Job from '@/views/Job.vue'
import Model from '@/views/Model.vue'
import Cop from '@/views/Cop.vue'
import GraphicalSensorView from '@/views/GraphicalSensorView.vue'
import Automated from "./views/Automated";
import AutomatedConfigEditor from "./views/AutomatedConfigEditor";
import PowerConsumption from "./views/PowerConsumption";
import OptimisationSimulation from "./views/OptimisationSimulation";
import DashboardGateway from "./views/DashboardGateway";
import KPIView from "./views/KPIView";
import Circuits from "./views/Circuits";
import EnergyTrend from "./views/EnergyTrend";
import DefaultDashboard from "./views/dashboards/DefaultDashboard";
import ShtDetailedDashboard from "./views/ShtDetailedDashboard";
import MonthlySummary from "./views/MonthlySummary";
import TestMonthlySummary from "./views/TestMonthlySummary";
import KeySavings from "./views/KeySavings";
import Observations from "./views/Observations";
import store from './store'
import FaultAnalysis from "./views/FaultAnalysis";
import HKLEnergy from "./views/HKLEnergy";
import HKLKPI from "./views/HKLKPI";
import FacilityOverview from "./views/FacilityOverview";
import FacilityOverview2 from "./views/FacilityOverview2";
import COP3D from "./views/COP3D";
import EsDashboardOld from "./views/dashboards/EsDashboardOld";
import NotificationBreakdown from "./views/NotificationBreakdown";
import CoolingLoadVSOAT from "./views/CoolingLoadVSOAT";
import ChillerSequencingFLA from "./views/ChillerSequencingFLA";
import ChillerSequencingDelta from "./views/ChillerSequencingDelta";
import AnomalyDescription from "./views/AnomalyDescription";
import FaultComparisson from "./views/FaultComparisson";
import EquipmentPlots from "./views/EquipmentPlots";
import AAPumpRuntime from "./views/AAPumpRuntime";
import AAAhuRuntime from "./views/AAAhuRuntime";
import AAKPI from "./views/AAKPI";
import PowerForecast from './views/PowerForecast'
import AAReport from "./views/AAReport";
import AAAhuControls from "./views/AAAhuControls";
import AAAhuDamper from "./views/AAAhuDamper";
import AACompleteFaultsReport from "./views/AACompleteFaultsReport";
import UserAutomated from "./views/UserAutomated";
import EquipmentSummary from "./views/EquipmentSummary";
import OptimizationSaving from "./views/OptimizationSaving";
import ExecutiveSummary from "./views/ExecutiveSummary";
import MTRExecutiveOverview from "./views/MTRExecutiveOverview";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL_OVERRIDE&&process.env.VUE_APP_BASE_URL_OVERRIDE!=="" ? process.env.VUE_APP_BASE_URL_OVERRIDE : process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: (process.env.VUE_APP_HIDE_TOOLBAR=='yes')? AnomalyDetection:  DashboardGateway
    },
    {
      path: '/overview',
      name: 'overview',
      component: DashboardGateway
    },{
      path: '/executive-overview',
      name: 'executive-overview',
      component: MTRExecutiveOverview
    },{
      path: '/anomaly-description',
      name: 'anomaly-description',
      component: AnomalyDescription
    },{
      path: '/aa-pump-runtime',
      name: 'aa-pump-runtime',
      component: AAPumpRuntime
    },{
      path: '/executive-summary',
      name: 'executive-summary',
      component: ExecutiveSummary
    },{
      path: '/aa-ahu-runtime',
      name: 'aa-ahu-runtime',
      component: AAAhuRuntime
    },
    {
      path: '/aa-ahu-controls',
      name: 'aa-ahu-controls',
      component: AAAhuControls
    },{
      path: '/aa-ahu-damper',
      name: 'aa-ahu-damper',
      component: AAAhuDamper
    },
    {
      path: '/chiller-sequencing-fla',
      name: 'chiller-sequencing-fla',
      component: ChillerSequencingFLA
    },{
      path: '/chiller-sequencing-delta',
      name: 'chiller-sequencing-delta',
      component: ChillerSequencingDelta
    },{
      path: '/key-savings',
      name: 'key-savings',
      component: KeySavings
    },{
      path: '/fault-comparison',
      name: 'fault-comparison',
      component: FaultComparisson
    },
    {
      path: '/default-overview',
      name: 'default-overview',
      component: DefaultDashboard
    },{
      path: '/detailed-overview',
      name: 'detailed-overview',
      component: ShtDetailedDashboard
    },{
      path: '/monthly-summary',
      name: 'monthly-summary',
      component: MonthlySummary
    },{
      path: '/aa-report',
      name: 'aa-report',
      component: AAReport
    },{
      path: '/aa-complete-faults-report',
      name: 'aa-complete-faults-report',
      component: AACompleteFaultsReport
    },{
      path: '/test-monthly-summary',
      name: 'test-monthly-summary',
      component: TestMonthlySummary
    },
    {
      path: '/load',
      name: 'load',
      component: CoolingLoad
    },{
      path: '/cop3d',
      name: 'cop3d',
      component: COP3D
    },
    {
      path: '/facility-overview',
      name: 'facility-overview',
      component: FacilityOverview
    },
    {
      path: '/facility-overview2',
      name: 'facility-overview2',
      component: FacilityOverview2
    },
    {
      path: '/sensors',
      name: 'sensors',
      component: Sensors
    },
    {
      path: '/fault',
      name: 'fault',
      component: Fault
    },{
      path: '/es-demo',
      name: 'es-demo',
      component: EsDashboardOld
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/controllogic',
      name: 'controllogic',
      component: ControlLogic
    },
    {
      path: '/notifications',
      name: 'notifications',
      component: Notifications
    },
    {
      path: '/notification-breakdown',
      name: 'notification-breakdown',
      component: NotificationBreakdown
    },
    {
      path: '/condenser',
      name: 'condenser',
      component: CondenserHealth
    },
    {
      path: '/evaporator',
      name: 'evaporator',
      component: EvaporatorHealth
    },
    {
      path: '/refrigerant',
      name: 'refrigerant',
      component: RefrigerantHealth
    },
    {
      path: '/compressor',
      name: 'compressor',
      component: CompressorHealth
    },{
      path: '/cl-vs-oat',
      name: 'cl-vs-oat',
      component: CoolingLoadVSOAT
    },
    {
      path: '/plot/facet',
      name: 'facetplots',
      component: FacetPlots
    },
    {
      path: '/energyefficiency',
      name: 'energyefficiency',
      component: EnergyEfficiency
    },
    {
      path: '/hkl-energy',
      name: 'hkl-energy',
      component: HKLEnergy
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/report',
      name: 'report',
      component: Report
    },
    {
      path: '/help',
      name: 'help',
      component: Help
    },
    {
      path: '/modelsummary',
      name: 'modelsummary',
      component: AnomalySummaryView
    },
    {
      path: '/maintenancerecord',
      name: 'maintenancerecord',
      component: MaintenanceRecord
    },
    {
      path: '/controloutput',
      name: 'controloutput',
      component: DynamicControlOutputPoints
    },
    {
      path: '/anomaly',
      name: 'anomaly',
      component: AnomalyDetection
    },
    {
      path: '/summary',
      name: 'summary',
      component: Summary
    },
    {
      path: '/rules',
      name: 'rules',
      component: Rules
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      meta: { public: true }
    },
    {
      path: '/refrigerantcalculate',
      name: 'refrigerantcalculate',
      component: Refrigerant
    },
    {
      path: '/users',
      name: 'users',
      component: Users
    },
    {
      path: '/equipments',
      name: 'equipments',
      component: Equipments
    },
    {
      path: '/facility',
      name: 'facility',
      component: Facility
    },
    {
      path: '/points',
      name: 'points',
      component: Points
    },
    {
      path: '/config',
      name: 'config',
      component: Config
    },
    {
      path: '/parameter',
      name: 'parameter',
      component: Parameter
    },
    {
      path: '/KPI',
      name: 'KPI',
      component: KPI
    },
    {
      path: '/hkl-kpi',
      name: 'hkl-kpi',
      component: HKLKPI
    },
    {
      path: '/aa-kpi',
      name: 'aa-kpi',
      component: AAKPI
    },
    {
      path: '/viewdata',
      name: 'viewdata',
      component: ViewData
    },
    {
      path: '/multiplots',
      name: 'multiplots',
      component: MultiPlots
    },{
      path: '/equipment-plots',
      name: 'equipment-plots',
      component: EquipmentPlots
    },{
      path: '/equipment-summary',
      name: 'equipment-summary',
      component: EquipmentSummary
    },
    {
      path: '/job',
      name: 'job',
      component: Job
    },
    {
      path: '/model',
      name: 'model',
      component: Model
    },
    {
      path: '/cop',
      name: 'cop',
      component: Cop
    },
    {
      path: '/graphical',
      name: 'graphical',
      component: GraphicalSensorView
    },
    {
      path: '/automated/:id',
      name: 'automated',
      component: Automated
    },
    {
      path: '/user-automated/:id',
      name: 'user-automated',
      component: UserAutomated
    },
    {
      path: '/automated-config-editor',
      name: 'automatedConfigEditor',
      component: AutomatedConfigEditor
    },
    {
      path: '/demo-dashboard',
      name: 'demoDashboard',
      component: DashboardGateway
    },{
      path: '/power-consumption',
      name: 'powerConsumption',
      component: PowerConsumption
    },{
      path: '/fault-analysis',
      name: 'faultAnalysis',
      component: FaultAnalysis
    },{
      path: '/optimisation-simulation',
      name: 'optimisationSimulation',
      component: OptimisationSimulation
    },{
      path: '/kpi-view',
      name: 'kpiView',
      component: KPIView
    },{
      path: '/circuits',
      name: 'circuits',
      component: Circuits
    },{
      path: '/energy-trend',
      name: 'energyTrend',
      component: EnergyTrend
    },
    {
      path: '/observations',
      name: 'observations',
      component: Observations
    },
    {
      path: '/powerforecast',
      name: 'powerforecast',
      component: PowerForecast
    },
    {
      path: '/optimizationsaving',
      name: 'optimizationsaving',
      component: OptimizationSaving
    }
  ]
})


router.beforeEach((to, from, next) => {


  if (to.matched.some(r => r.meta.guest) && store.state.userStore.user) {
    next({ name: 'home' })
    return
  }
  next()
})

export default router
